<div class="driver-view-container">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
  <div class="driver-view">
    <div class="heading">
      <h3>Driver Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <div class="input-fileds-container category-edit">
      <form action="" [formGroup]="profileForm" class="admin-forms mt-3">
        <div class="row">
          <div class="col-md-9">
            <!-- Driving License & DOB Verification Box -->
            <div class="dl-verify-box">
              <div class="dl-verify-box-header">
                <div class="dl-verify-title">
                  <img src="../../../assets/img/tick-verify.svg" *ngIf="isDlVerified" class="verify-icon-success" />
                  <span>Driving License Verification</span>
                </div>
                <div class="dl-verify-subtitle" *ngIf="!isDlVerified">
                  Enter DL Number & DOB, then click Verify
                </div>
                <div class="dl-verify-subtitle text-success" *ngIf="isDlVerified">
                  ✓ Verified with National Register (Sarathi)
                </div>
              </div>

              <div class="row dl-verify-row">
                <div class="col-md-5">
                  <div class="head">Driving License Number<span class="required-asterisk">*</span></div>
                  <div>
                    <mat-form-field>
                      <input
                        toUppercase
                        matInput
                        formControlName="driving_license_number"
                        minlength="10"
                        maxlength="20"
                        placeholder="e.g. GJ04 20120005008"
                        (input)="onDlNumberChange()"
                        [readonly]="isFieldRestricted('driving_license_number')"
                        [class.field-restricted]="isFieldRestricted('driving_license_number')"
                        required
                      />
                      <mat-error
                        *ngIf="(ProfileFormControl['driving_license_number'].touched) && ProfileFormControl['driving_license_number'].errors?.['required']"
                      >
                        License is required</mat-error
                      >
                      <mat-error
                        *ngIf="(ProfileFormControl['driving_license_number'].touched) && ProfileFormControl['driving_license_number'].errors?.['pattern']"
                      >
                        Please enter a Valid License Number</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-md-7">
                  <div class="head">DOB<span class="required-asterisk">*</span></div>
                  <div class="dob-verify-wrapper">
                    <mat-form-field class="dob-input-field">
                      <input
                        matInput
                        [matDatepicker]="picker1"
                        [max]="minDob"
                        formControlName="dob"
                        (change)="onDateChnage(2)"
                        (click)="!isFieldRestricted('dob') && picker1.open()"
                        [readonly]="isFieldRestricted('dob')"
                        [class.field-restricted]="isFieldRestricted('dob')"
                      />
                      <mat-datepicker #picker1 [disabled]="isFieldRestricted('dob')"></mat-datepicker>
                      <mat-error
                        *ngIf='ProfileFormControl["dob"].touched && ProfileFormControl["dob"].errors?.["required"]'
                      >
                        Date of birth is required</mat-error
                      >
                      <mat-error *ngIf="invalidDob"
                        >Please select valid Date of birth</mat-error
                      >
                    </mat-form-field>

                    <div class="verify-btn-container">
                      <button
                        type="button"
                        class="verify-action-btn"
                        (click)="verifyDrivingLicense()"
                        [disabled]="isDlVerifying"
                        *ngIf="!isDlVerified"
                        title="Verify Driving License & DOB with Sarathi"
                      >
                        <span *ngIf="!isDlVerifying">Verify</span>
                        <span *ngIf="isDlVerifying" class="inline-spinner-white"></span>
                      </button>

                      <div *ngIf="isDlVerified" class="d-flex align-items-center gap-1 verify-status-wrapper">
                        <img src="../../../assets/img/tick-verify.svg" style="width: 24px; height: 24px;" title="Verified with Sarathi" />
                        <a
                          *ngIf="!data"
                          (click)="resetDlVerification()"
                          class="change-dl-link"
                          title="Change DL / Re-verify"
                          >Change</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Verified DL Information Card inside the box -->
              <div class="mt-2" *ngIf="isDlVerified && dlVerificationData">
                <div class="dl-verified-card">
                  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div class="dl-meta">
                      <span class="meta-label">RTO:</span>
                      <span class="meta-value">{{ dlVerificationData.rto || dlVerificationData.dlobj?.omRtoFullname || 'National Register' }}</span>
                      <span class="meta-divider">•</span>
                      <span class="meta-label">Status:</span>
                      <span class="meta-status text-success">{{ dlVerificationData.status || dlVerificationData.dlobj?.dlStatus || 'Active' }}</span>
                      <span class="meta-divider" *ngIf="dlVerificationData.validity || dlVerificationData.dlobj?.dlTrValdtoDt">•</span>
                      <span class="meta-label" *ngIf="dlVerificationData.validity || dlVerificationData.dlobj?.dlTrValdtoDt">Valid Till:</span>
                      <span class="meta-value" *ngIf="dlVerificationData.validity || dlVerificationData.dlobj?.dlTrValdtoDt">{{ dlVerificationData.validity || dlVerificationData.dlobj?.dlTrValdtoDt }}</span>
                    </div>
                    <div class="dl-badge-wrapper">
                      <span
                        [ngClass]="hasTransportAuthorization ? 'badge-transport-yes' : 'badge-transport-no'"
                        class="transport-badge"
                        [title]="hasTransportAuthorization ? 'Authorized for commercial heavy vehicles' : 'Only non-transport vehicles allowed'"
                      >
                        {{ hasTransportAuthorization ? '✓ Commercial / Transport (TRANS) Authorized' : '⚠ Non-Transport Only (LMV/NT)' }}
                      </span>
                    </div>
                  </div>
                  <div *ngIf="dlVerificationData.classOfVehicle" class="mt-1" style="font-size: 11px; color: #475569;">
                    <strong>Vehicle Classes:</strong> {{ dlVerificationData.classOfVehicle }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Row 2: Driver Name & Mobile Number -->
            <div class="row mtb">
              <div class="col-md-5">
                <div class="head">Driver Name<span class="required-asterisk">*</span></div>
                <div>
                  <mat-form-field>
                    <input
                      matInput
                      formControlName="username"
                      style="text-transform: capitalize"
                      [readonly]="isFieldRestricted('username')"
                      [class.field-restricted]="isFieldRestricted('username')"
                      required
                    />
                    <mat-error>Please Enter Driver Name</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-7">
                <div class="head">Mobile Number<span class="required-asterisk">*</span></div>
                <div>
                  <mat-form-field>
                    <input
                      matInput
                      formControlName="mobile"
                      minlength="10"
                      maxlength="10"
                      required
                      [readonly]="ismobileVerified"
                      (keypress)="validateNumber($event)"
                    />
                    <div class="otp-field" *ngIf="mobileVerified === 0">
                      <img src="../../../assets/img/error.svg" />
                      <a
                        (click)="mobileVerification()"
                        class="otp"
                        style="color: brown"
                        >Send OTP</a
                      >
                    </div>
                    <div class="otp-field" *ngIf="mobileVerified > 0">
                      <img src="../../../assets/img/tick-verify.svg" />
                      <a *ngIf="data && !isEditingMobile" (click)="enableMobileEdit()" style="cursor: pointer; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; background: #f0f4f8; border-radius: 50%; transition: background 0.2s;" onmouseover="this.style.background='#e2e8f0'" onmouseout="this.style.background='#f0f4f8'">
                        <img src="../../../assets/img/edit.svg" alt="Edit" style="width: 18px; height: 18px;" title="Edit Contact Number" />
                      </a>
                    </div>
                    <mat-error>Please Enter Mobile Number</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Row 3: Email & Emergency Number -->
            <div class="row mtb">
              <div class="col-md-5">
                <div class="head">Email</div>
                <div>
                  <mat-form-field>
                    <input matInput type="email" formControlName="email" />
                    <mat-error
                      *ngIf="
                        profileForm.get('email')?.touched
                        && profileForm.get('email')?.value
                        && profileForm.get('email')?.hasError('invalidEmail')
                      "
                    >
                      Please enter a valid email address
                    </mat-error>
                    <div class="otp-field" *ngIf="emailVerified === 0"></div>
                    <div class="otp-field" *ngIf="emailVerified > 0">
                      <img src="../../../assets/img/tick-verify.svg" />
                    </div>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-7">
                <div class="head">Emergency Number</div>
                <div>
                  <mat-form-field>
                    <input
                      matInput
                      minlength="10"
                      maxlength="10"
                      formControlName="emergency_contact"
                      (keypress)="validateNumber($event)"
                    />
                    <mat-error
                      *ngIf="(ProfileFormControl['emergency_contact'].touched) && ProfileFormControl['emergency_contact'].errors?.['pattern']"
                    >
                      Please enter a valid emergency number</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Row 4: Gender & Assigned Truck Number -->
            <div class="row mtb">
              <div class="col-md-5">
                <div class="head">Gender<span class="required-asterisk">*</span></div>
                <div class="driver-truck">
                  <mat-form-field appearance="fill">
                    <mat-select formControlName="gender" placeholder="Select Gender">
                      <mat-option value="male">Male</mat-option>
                      <mat-option value="female">Female</mat-option>
                      <mat-option value="others">Others</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-7">
                <div class="head">Assigned Truck Number</div>
                <div class="driver-truck assigned-truck-select" *ngIf="truckDropDownDispaly">
                  <mat-form-field appearance="fill">
                    <mat-select
                      formControlName="truck_id"
                      placeholder="Select truck"
                    >
                      <mat-option
                        *ngFor="let item of truckList"
                        value="{{ item._id }}"
                      >
                        {{ item.truck_number }}</mat-option
                      >
                    </mat-select>
                    <mat-error>Truck number is required</mat-error>
                  </mat-form-field>
                </div>
                <div
                  class="assigned-truck-select"
                  *ngIf="!truckDropDownDispaly"
                  (click)="TruckAssigneClicked()"
                >
                  <mat-form-field>
                    <input matInput formControlName="truck_name" readonly />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Row 5: Driver Known Languages & Status / Reason -->
            <div class="row mtb">
              <div class="col-md-5">
                <div class="head">Driver Known Languages<span class="required-asterisk">*</span></div>
                <div class="driver-truck">
                  <mat-form-field appearance="fill">
                    <mat-select
                      #langSelect
                      dropLocationSearchField
                      formControlName="known_lang"
                      placeholder="Select Languages"
                      multiple
                    >
                      <mat-option
                        *ngFor="let lang of languageId"
                        [value]="lang.name"
                      >
                        {{ lang.name }}
                      </mat-option>
                      <div
                        class="d-flex justify-content-center align-items-center"
                      >
                        <button class="langbtn btn" (click)="onDoneClick()">
                          Done
                        </button>
                      </div>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-7" *ngIf="status">
                <div class="row">
                  <div class="col-md-6">
                    <div class="head">Status</div>
                    <div class="driver-truck">
                      <mat-form-field appearance="fill">
                        <mat-select formControlName="driver_status">
                          <mat-option value="requested" disabled>Requested</mat-option>
                          <mat-option value="available" disabled>Available</mat-option>
                          <mat-option value="allocated" disabled>Allocated</mat-option>
                          <mat-option value="rejected" (click)="reject()">Rejected</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-md-6" *ngIf="profileForm.get('driver_status')?.value === 'rejected'">
                    <div class="head">Reason</div>
                    <div class="driver-truck">
                      <mat-form-field appearance="fill">
                        <input matInput formControlName="driver_remarks" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="right-img">
              <button (click)="uploadImage.click()" [disabled]="imgLoading">
                <img
                  src="{{
                    profileForm.value.profile_image
                      ? profileForm.value.profile_image
                      : '../../../assets/img/defaultDP.png'
                  }}"
                  class="driverImg"
                />
                <div class="image-upload-area mt-3">
                  <span class="image">
                    <p [class.spinner]="imgLoading">Add/Replace Driver Image</p>
                  </span>
                  <input
                    #uploadImage
                    type="file"
                    (change)="onChange($event)"
                    hidden
                  />
                </div>
              </button>
            </div>
          </div>
        </div>
      </form>
      <div class="heading">
        <h3>Documents</h3>
      </div>
      <mat-divider></mat-divider>
      <form action="" [formGroup]="documentForm" class="admin-forms mt-3">
        <div class="row">
          <div class="col-md-12">
            <div class="row mtb">
              <div class="col-md-4 d-flex align-items-center">
                <div class="">Driving License<span class="required-asterisk">*</span></div>
              </div>
              <div class="col-md-4">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      [matDatepicker]="picker2"
                      [min]="today"
                      placeholder="License Expiry Date"
                      formControlName="driving_license_expiry"
                      (change)="onDateChnage(3)"
                      (click)="!isFieldRestricted('driving_license_expiry') && picker2.open()"
                      [readonly]="isFieldRestricted('driving_license_expiry')"
                      [class.field-restricted]="isFieldRestricted('driving_license_expiry')"
                    />
                    <mat-datepicker #picker2 [disabled]="isFieldRestricted('driving_license_expiry')"></mat-datepicker>
                    <mat-error
                      *ngIf='documentFormControl["driving_license_expiry"].touched && documentFormControl["driving_license_expiry"].errors?.["required"]'
                    >
                      License expiry date is required</mat-error
                    >
                    <mat-error *ngIf="invalidDocLicense"
                      >Please select valid License expiry date
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div
                class="col-md-4 d-flex align-items-center justify-content-center"
              >
                <div class="">
                  <span *ngIf="licenseImageName"
                    >{{ licenseImageName.substring(0, 5) + "..." }}
                    <img
                      src="../../../assets/img/cross.svg"
                      class="ms-2"
                      alt=""
                      (click)="cancelLicenseImage()"
                    />
                  </span>
                  <span class="image ms-3" (click)="uploadLicenseImage.click()"
                    >Upload</span
                  >
                  <div [class.spinner]="drivingLicenceLoading"></div>

                  <div *ngIf="!licenseImageName">{{ drivingLicence }}</div>
                  <input
                    #uploadLicenseImage
                    type="file"
                    (click)="uploadLicenseImage.value = ''"
                    (change)="onChangeLicense($event)"
                    hidden
                  />
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-4 d-flex align-items-center">
                <div class="">Insurance</div>
              </div>

              <div class="col-md-4">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      [matDatepicker]="picker3"
                      [min]="today"
                      placeholder="Insurance Expiry Date"
                      formControlName="insurance_expiry"
                      (change)="onDateChnage(4)"
                      (click)="picker3.open()"
                    />
                    <!-- <mat-datepicker-toggle
                      matSuffix
                      [for]="picker3"
                    ></mat-datepicker-toggle> -->
                    <mat-datepicker #picker3></mat-datepicker>
                    <mat-error *ngIf="invalidInsuranceDate"
                      >Please select valid Insurance expiry date
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div
                class="col-md-4 d-flex align-items-center justify-content-center"
              >
                <div class="">
                  <span *ngIf="insuranceImageName"
                    >{{ insuranceImageName.substring(0, 5) + "..." }}
                    <img
                      src="../../../assets/img/cross.svg"
                      class="ms-2"
                      alt=""
                      (click)="cancelInsuranceImage()"
                  /></span>
                  <div [class.spinner]="insuranceLoading"></div>

                  <div *ngIf="!insuranceImageName">{{ insurance }}</div>
                  <span
                    class="image ms-3"
                    (click)="uploadInsuranceImage.click()"
                    >Upload</span
                  >
                  <input
                    #uploadInsuranceImage
                    type="file"
                    (click)="uploadInsuranceImage.value = ''"
                    (change)="onChangeInsurance($event)"
                    hidden
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="heading">
        <h3>Contact Details</h3>
      </div>
      <mat-divider></mat-divider>
      <form action="" [formGroup]="contactForm">
        <div class="row">
          <div class="col-md-9">
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Name</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="name" required />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Contact Number</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      formControlName="mobile"
                      minlength="10"
                      maxlength="10"
                      required
                      (keypress)="validateNumber($event)"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Email</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput type="email" formControlName="email" />
                    <mat-error
                      *ngIf="
                        contactForm.get('email')?.touched
                        && contactForm.get('email')?.value
                        && contactForm.get('email')?.hasError('invalidEmail')
                      "
                    >
                      Please enter a valid email address
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Address Line</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="address_line" required />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Area</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="area" required />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">City</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      type="text"
                      matInput
                      formControlName="city"
                      required
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">State</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="state" required />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Pincode</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      appNumericOnly
                      formControlName="pincode"
                      minlength="6"
                      maxlength="6"
                      required
                      (keypress)="validateNumber($event)"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
            
            <!-- <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">GST</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      appAlphanumericOnly
                      toUppercase
                      formControlName="gst"
                      minlength="15"
                      maxlength="15"
                    />
                    <mat-error
                      *ngIf="(contactFormControl['gst'].touched) && contactFormControl['gst'].errors?.['pattern']"
                    >
                      Please enter Valid GST Number</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </form>
      <br />
      <br />
      <div class="fixed-btn">
        <button
          type="submit"
          *ngIf="!data"
          [class.spinner]="loading"
          [ngClass]="{ 'button-disabled': loading || !profileForm.valid }"
          [disabled]="loading || !profileForm.valid"
          (click)="onSave($event)"
        >
          Save
        </button>
        <button
          *ngIf="data"
          type="button"
          [class.spinner]="loading"
          [ngClass]="{ 'button-disabled': loading || !profileForm.valid }"
          [disabled]="loading || !profileForm.valid"
          (click)="onEditSave($event)"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</div>
